import React from 'react'
import { Table, Menu, ActionIcon, Text, NumberFormatter, Paper, Image } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'
import NoImage from '../../../../../assets/img/images/no-images.png'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={150} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderProofOfPaymentTable = ({ label, data, actionMethod }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.bank}</Table.Td>
        <Table.Td>{val.customer_name}</Table.Td>
        <Table.Td>{val.account_number}</Table.Td>
        <Table.Td>
          <Text fz={13} fw='500'><NumberFormatter thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.total_paid || 0} /></Text>
        </Table.Td>
        <Table.Td>{val.transfer_date ? dayjs(val.transfer_date).format('DD-MM-YYYY') : '-'}</Table.Td>
        <Table.Td>{val.customer_name}</Table.Td>
        <Table.Td>{val.transfer_to || '-'}</Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={52} withBorder radius='md'>
            <Image w={50} h={50} radius='md' src={val.proof_of_transfer !== null ? val.proof_of_transfer : NoImage} />
          </Paper>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })


  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderProofOfPaymentTable